module.exports = __webpack_public_path__ + "assets/img/five.a611ec47.png";